"use client";

import dynamic from "next/dynamic";

import { BasketIcon } from "@jti/brand-icons/basket";
import { ShoppingBagIcon } from "@jti/brand-icons/shopping-bag";
import { useFeatureFlags } from "@jti/commerce";
import { HeaderToolsItem } from "@jti/ui/eva-components/MobileFirstHeader/components/HeaderToolsItem";

import { useCheckoutNavigationHandler } from "@/hooks/useCheckoutNavigationHandler";

import styles from "./CartMini.module.scss";

const CartMiniApp = dynamic(async () => (await import("@jti/checkout/cart-mini")).CartMiniApp, {
  ssr: false,
  loading: () => <HeaderToolsItem data-testid="cartIcon" icon={ShoppingBagIcon} aria-hidden="true" />,
});

const MiniCartApp = dynamic(async () => (await import("@jti/cart/MiniCartApp")).MiniCartApp, {
  ssr: true,
  loading: () => <BasketIcon className={styles.icon} />,
});

type CartMiniProps = {
  shopButtonLabel?: string;
};

export const CartMini = ({ shopButtonLabel }: CartMiniProps) => {
  const { ffNewMiniCartEnable } = useFeatureFlags();
  const handleNavigate = useCheckoutNavigationHandler();

  return (
    <div className={styles.cartMiniWrapper}>
      {ffNewMiniCartEnable ? (
        <MiniCartApp />
      ) : (
        <CartMiniApp onNavigate={handleNavigate} shopButtonLabel={shopButtonLabel} />
      )}
    </div>
  );
};
